module.exports = __webpack_public_path__ + "img/blue_051.f5cf0d09.png";